// Definimos el Custom Element 'cart-upsell-carousel' que es el contenedor del carrusel en Liquid.
// Esto permite que la lógica JavaScript se conecte automáticamente cuando el elemento HTML de upsell cargue.
if (!customElements.get('cart-upsell-carousel')) {
  customElements.define('cart-upsell-carousel', class CartUpsellCarousel extends HTMLElement {
    connectedCallback() {
      // 1. Intentar inicializar Swiper inmediatamente (para el primer inicio)
      this.init();
      
      // 2. Suscribirse a actualizaciones del carrito via el sistema "PUB_SUB_EVENTS" del tema.
      // Cuando el carrito cambia (ej: se sube/baja una cantidad), Shopify suele volver a
      // cargar partes del DOM. Tenemos que esperar y re-inicializar el carrusel.
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          setTimeout(() => this.init(), 500);
        });
      }

      // 3. Vigilar el Drawer por cambios de clase por si se abre y Swiper quedó inactivo
      this.setupObserver();
    }

    init() {
      const container = this.querySelector('.cart-upsell__swiper');
      if (!container) return;

      // Esperar iterativamente a que la librería global 'Swiper', inyectada en Liquid, esté disponible
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.init(), 100);
        return;
      } 

      // IMPORTANTE: Si Swiper ya había sido inicializado, lo destruimos completamente (limpieza).
      // Evita bugs visuales o duplicado de eventos y botones "trancados" después del Ajax.
      if (container.swiper) {
        container.swiper.destroy(true, true);
      }

      this.swiper = new Swiper(container, {
        slidesPerView: 4,
        spaceBetween: 10,
        loop: true,
        loopedSlides: 3,
        grabCursor: true,
        navigation: {
          nextEl: this.querySelector('.cart-upsell__btn--next'),
          prevEl: this.querySelector('.cart-upsell__btn--prev'),
        },
        breakpoints: {
          320: { slidesPerView: 2, spaceBetween: 8 },
          480: { slidesPerView: 4, spaceBetween: 10 }
        },
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        on: {
          init: () => {
            setTimeout(() => {
              if (this.swiper) {
                this.swiper.update();
                this.swiper.navigation.update();
              }
            }, 400);
          }
        }
      });
      console.log('Cart Upsell Swiper Initialized');
    }

    setupObserver() {
      // Observamos mutaciones en la clase del 'cart-drawer' principal.
      // Específicamente, buscamos la clase 'active' para saber que el drawer se abrió.
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (drawer.classList.contains('active')) {
               // Cuando se abre exitosamente, damos tiempo al CSS y luego repintamos el carrusel.
               setTimeout(() => {
                 this.init();
               }, 200);
            }
          }
        });
      });
      observer.observe(drawer, { attributes: true });
    }
  });
}

// Declarar función universal `addUpsellToCart` en window para que sea accesible usando 
// el atributo nativo onclick="addUpsellToCart(...)" del HTML dentro del Upsell Slide.
if (typeof addUpsellToCart === 'undefined') {
    window.addUpsellToCart = async function(productId, variantId) {
      if (!variantId) return;
      
      // Mostrar overlay de carga en el carrito principal temporalmente
      const loader = document.getElementById('CartDrawer-CartItems');
      if (loader) loader.classList.add('loading');

      try {
        // Llamada nativa de Shopify AJAX API para añadir productos al carrito (solo sumará, sin refescar la página entera)
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (response.ok) {
           // Notificamos a la tienda que debe volver a rendrizar el HTML del cart drawer completo
           if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
           } else {
              // Fallback: Si la tienda no soporta ese evento del tema, forzamos recarga pesada
              location.reload();
           }
        }
      } catch (error) {
        console.error('Error adding upsell:', error);
      }
    }
}
